import { loginRequest, apiConfig } from "../authConfig";
import { msalInstance } from "../msalInstance";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { toApiError } from "./apiError";
import axios from "axios";

export async function callApi(request) {
  const { method, url, params, data, responseType } = request;
  const extraHeaders = request.headers || {}; // allow callers to set Accept etc
  const account = msalInstance.getActiveAccount();
  if (!account) {
    throw Error(
      "No active account! Verify a user has been signed in and setActiveAccount has been called.",
    );
  }

  const handleAcquireTokenSilentError = (error) => {
    if (error instanceof InteractionRequiredAuthError) {
      // fallback to interaction when silent call fails
      msalInstance.acquireTokenRedirect(loginRequest);
      throw new Error("Interaction required to acquire a new auth token.");
    }
    console.warn("Other silent token error: ", error);
    throw new Error("handleAcquireTokenSilentError");
  };

  const response = await msalInstance
    .acquireTokenSilent({
      ...loginRequest,
      account: account,
    })
    .catch(handleAcquireTokenSilentError);

  const accessToken = response.accessToken;
  const bearer = `Bearer ${accessToken}`;

  const headers = {
    Authorization: bearer,
  };

  // Only set Content-Type when we actually send a JSON body (POST/PUT/PATCH)
  const upperMethod = (method || "").toUpperCase();
  if (
    data !== undefined &&
    upperMethod &&
    upperMethod !== "GET" &&
    upperMethod !== "DELETE"
  ) {
    headers["Content-Type"] = "application/json";
  }

  // If caller asked for a blob (likely an image) set a generic Accept unless caller already provided one.
  if (request.responseType === "blob" && !extraHeaders["Accept"]) {
    headers["Accept"] = "image/*";
  }
  // Merge any extra headers (caller provided overrides ours, including Accept)
  Object.assign(headers, extraHeaders);

  try {
    return await axios({
      method: method,
      url: `${apiConfig.uri}/${url}`,
      params: params,
      headers: headers,
      data: data,
      responseType: responseType, // allow callers to request blob/arraybuffer etc
    });
  } catch (error) {
    throw await toApiError(error);
  }
}
